import React, { Fragment } from 'react';
import LocationForm from './LocationForm';
import withLocation from './withLocation';

const LocationUpdatePageView = ({ location }) => (
  <Fragment>
    <nav className="navbar navbar-expand navbar-light bg-light">
      <div className="navbar-brand">
        Locatie {location.name} wijzigen
      </div>
    </nav>
    <div className="container-fluid my-4">
      <div className="row">
        <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
          <div className="card">
            <div className="card-body">
              <LocationForm update={location} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
);

export default withLocation(LocationUpdatePageView);
